export enum HealthReportRange {
	DAYS7 = "DAYS7",
	DAYS30 = "DAYS30",
	DAYS90 = "DAYS90",
	MONTHS12 = "MONTHS12",
	ALL_TIME = "ALL_TIME",
}

export enum HealthReportAction {
	EMAIL = "EMAIL",
	VIEW = "VIEW",
}
